/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

var props = {
  animation: {
    type: String,
    "default": "none",
    validator: function validator(val) {
      if (!val) return true;
      return ["gradient", "flashed", "none"].includes(val);
    }
  },
  delay: {
    type: Number,
    "default": 0
  },
  loading: {
    type: Boolean,
    "default": true
  },
  rowCol: {
    type: Array
  },
  theme: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["text", "avatar", "paragraph", "avatar-text", "tab", "article"].includes(val);
    }
  }
};

export { props as default };
//# sourceMappingURL=props.mjs.map
